import DefaultView from 'nette-base-module/js/views/default'
import merge from 'lodash/merge'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcMenuStore from '@/frontapp/store/bcMenu'
import { mapStores } from 'pinia'
import globalUploader from '../globalUploader'
import AsideModal from '@/frontapp/mixins/AsideModal'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default merge({
  mixins: [
    AsideModal,
    DocumentStore,
  ],
  computed: {
    globalUploader() {
      return globalUploader.value
    },
    isDocument() {
      const routesDocument = [
        'BCDocument', 
        'BCDocumentDetail', 
        'BCDocumentDetailRev',
      ]

      return routesDocument.includes(this.$route.matched[0].name)
    },
    ...mapStores(useBcFolderStore, useBcMenuStore)
  }
}, DefaultView)
